import { Children, isValidElement, type ReactNode } from "react";
import classNames from "classnames";

export interface DetailsCardThreeColumnRowProps {
  children: ReactNode;
  className?: string;
  /**
   * Adds `pt-12` (48px) above the row. Set when no `SectionHeading` sits above the grid —
   * including first under tabs and after MetricGrid or other section content.
   */
  tabBodySpacing?: boolean;
}

/**
 * Even three-column row for {@link DetailsCard} content on medium+ breakpoints.
 * Stacks to a single column on small screens. Null children are omitted.
 */
export default function DetailsCardThreeColumnRow({
  children,
  className,
  tabBodySpacing = false
}: DetailsCardThreeColumnRowProps) {
  const items = Children.toArray(children).filter((child) => isValidElement(child));

  return (
    <div
      className={classNames(
        "flex flex-col md:flex-row gap-x-10 gap-y-10 min-w-0 items-stretch",
        tabBodySpacing && "pt-12",
        className
      )}
      data-testid="details-card-three-column-row"
    >
      {items.map((child, index) => (
        <div key={index} className="min-w-0 md:flex-1 md:basis-0">
          {child}
        </div>
      ))}
    </div>
  );
}
